import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const getProducts = () => api.get("/products").then((r) => r.data);
export const getEpisodes = () => api.get("/episodes").then((r) => r.data);
export const createCheckout = (items, originUrl, customer = {}) =>
  api
    .post("/checkout", {
      items,
      origin_url: originUrl,
      customer_email: customer.email || null,
      customer_name: customer.name || null,
      promo_code: customer.promo || null,
    })
    .then((r) => r.data);

export const validatePromo = (code) =>
  api.post("/promo/validate", { code }).then((r) => r.data);
export const getCheckoutStatus = (sessionId) =>
  api.get(`/checkout/status/${sessionId}`).then((r) => r.data);
export const subscribeNewsletter = (email) =>
  api.post("/newsletter", { email }).then((r) => r.data);
export const sendContact = (payload) =>
  api.post("/contact", payload).then((r) => r.data);

const authHeader = () => ({
  headers: { Authorization: `Bearer ${localStorage.getItem("mu_token") || ""}` },
});

export const adminLogin = (email, password) =>
  api.post("/auth/login", { email, password }).then((r) => r.data);
export const adminStats = () => api.get("/admin/stats", authHeader()).then((r) => r.data);
export const adminNewsletter = () =>
  api.get("/admin/newsletter", authHeader()).then((r) => r.data);
export const adminContacts = () =>
  api.get("/admin/contacts", authHeader()).then((r) => r.data);
export const adminOrders = () => api.get("/admin/orders", authHeader()).then((r) => r.data);
export const downloadSubscribersCsv = () =>
  api.get("/admin/newsletter.csv", { ...authHeader(), responseType: "blob" }).then((r) => r.data);
